import Button from "../Button";
import Card from "../Card";
import Modal from "./Modal";
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { useRef } from "react";

function PlayCardModal({ card, onPlay, onPass }) {
    const cardRef = useRef(null);
    const buttonsRef = useRef(null);

    useGSAP(() => {
        const tl = gsap.timeline();

        tl.fromTo(cardRef.current, {
            opacity: 0.7,
            y: -30,
        }, {
            opacity: 1,
            y: 0,
            ease: 'power1.out',
            duration: 0.333,
        })

        tl.fromTo(buttonsRef.current.querySelector('button:nth-child(1)'), {
            x: -8,
            opacity: 0,
        }, {
            x: 0,
            opacity: 1,
            ease: 'power1.out',
            duration: 0.15,
        }, 0.1)

        tl.fromTo(buttonsRef.current.querySelector('button:nth-child(2)'), {
            x: 8,
            opacity: 0,
        }, {
            x: 0,
            opacity: 1,
            ease: 'power1.out',
            duration: 0.15,
        }, 0.1)
    }, []);

    return (
        <Modal>
            <div ref={cardRef} className="basis-[35dvh] flex flex-col justify-end mb-8">
                <Card card={card}></Card>
            </div>
            <div ref={buttonsRef} className="flex gap-4">
                <Button onClick={onPlay} text={'Play'} styling="secondary" className={'w-28 opacity-0 -translate-x-2'}></Button>
                <Button onClick={onPass} text={'Keep'} styling="secondary" className={'w-28 opacity-0 translate-x-2'}></Button>
            </div>
        </Modal>
    );
}

export default PlayCardModal;